"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const SiteHeaderTool_1 = require("@components/molecules/SiteHeaderTool");
var facebookIcon = require("../../assets/images/icons/facebook.svg");
var twitterIcon = require("../../assets/images/icons/twitter.svg");
var emailIcon = require("../../assets/images/icons/email.svg");
var pinterestIcon = require("../../assets/images/icons/pinterest.svg"); // Component
var SocialSharingMenu = function SocialSharingMenu(_ref) {
    var title = _ref.title, description = _ref.description, imageUrl = _ref.imageUrl;
    var _React$useState = react_1.default.useState(undefined), manuallyOpen = _React$useState[0], setManuallyOpen = _React$useState[1];
    var autoOpen = _utils_1.useWaypoint({
        waypointSelector: '#topOfArticle',
        offset: -350
    });
    var autoClose = _utils_1.useWaypoint({
        waypointSelector: '#bottomOfArticle',
        offset: -200
    });
    var _React$useState2 = react_1.default.useState(""), pageUrl = _React$useState2[0], setPageUrl = _React$useState2[1];
    react_1.default.useEffect(function () {
        var windowExists = typeof window !== "undefined";
        setPageUrl(windowExists ? window.location.href : "");
    }, []);
    var toggleNav = function toggleNav() {
        return setManuallyOpen(manuallyOpen === undefined ? !autoOpen : !manuallyOpen);
    };
    var active = manuallyOpen === undefined ? autoOpen && !autoClose : manuallyOpen;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Trigger, {
        className: active ? 'active' : '',
        onClick: function onClick() {
            return toggleNav();
        }
    }, /*#__PURE__*/ react_1.default.createElement(SiteHeaderTool_1.ToolIcon, {
        color: _theme_1.palette.ink,
        className: active ? 'active' : ''
    }, "share"), /*#__PURE__*/ react_1.default.createElement(SiteHeaderTool_1.Cross, {
        color: _theme_1.palette.ink,
        className: active ? 'active' : ''
    })), /*#__PURE__*/ react_1.default.createElement(Options, {
        active: active
    }, /*#__PURE__*/ react_1.default.createElement(SocialItem, {
        color: _theme_1.palette.facebook
    }, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        logo: facebookIcon,
        target: "_blank",
        rel: "noopener",
        href: "https://www.facebook.com/sharer/sharer.php?u=" + pageUrl
    }, "share on Facebook")), /*#__PURE__*/ react_1.default.createElement(SocialItem, {
        color: _theme_1.palette.twitter
    }, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        logo: twitterIcon,
        target: "_blank",
        rel: "noopener",
        href: "https://twitter.com/share?url=" + pageUrl
    }, "share on Twitter")), imageUrl && /*#__PURE__*/ react_1.default.createElement(SocialItem, {
        color: _theme_1.palette.pinterest
    }, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        logo: pinterestIcon,
        target: "_blank",
        rel: "noopener",
        href: "http://pinterest.com/pin/create/button/?url=" + pageUrl + "&media=" + imageUrl + "&description=" + title + "\u2014" + description
    }, "share on Pinterest")), /*#__PURE__*/ react_1.default.createElement(SocialItem, {
        color: _theme_1.palette.email
    }, /*#__PURE__*/ react_1.default.createElement(SocialLink, {
        logo: emailIcon,
        target: "_blank",
        rel: "noopener",
        href: "mailto:?Subject=" + encodeURIComponent(title) + "&Body=\u201C" + encodeURIComponent(description) + "\u201D%0D%0D" + pageUrl
    }, "share via Email"))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "SocialSharingMenu__Wrapper",
    componentId: "vqd05t-0"
})(["display:none;@media only screen and (min-width:", "){position:relative;display:flex;align-items:center;justify-content:center;height:100%;width:64px;}"], _theme_1.breakpoint.tablet);
var Trigger = styled_components_1.default.div.withConfig({
    displayName: "SocialSharingMenu__Trigger",
    componentId: "vqd05t-1"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&::after{position:absolute;left:50%;bottom:0px;background-color:", ";width:100%;height:2px;transform-origin:center;transform:translate3d(-50%,0,0) scaleX(0);transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1);will-change:transform;content:'';}&.active::after{transform:translate3d(-50%,0,0) scaleX(1);}@media only screen and (min-width:", "){&:hover::after{transform:translate3d(-50%,0,0) scaleX(1);}}"], _theme_1.palette.brown, _theme_1.breakpoint.tablet);
/* Social Buttons */
var Options = styled_components_1.default.ul.withConfig({
    displayName: "SocialSharingMenu__Options",
    componentId: "vqd05t-2"
})(["z-index:0;position:absolute;top:calc(100% + 32px);right:50%;display:grid;grid-auto-flow:row;grid-gap:16px;background-color:", ";padding:16px;margin-right:-36px;border-radius:3px;transition:opacity 0.4s ease-in-out,transform 0.4s ease-in-out;transform:translateY(", ");opacity:", ";pointer-events:", ";@media only screen and (min-width:", "){top:calc(100% + 40px);}@media only screen and (min-width:", "){top:calc(100% + 48px);margin-right:-40px;}@media only screen and (min-width:", "){top:calc(100% + 64px);grid-gap:20px;padding:20px;margin-right:-52px;}"], _theme_1.palette.ivory, function (props) {
    return !props.active ? '24px' : '0px';
}, function (props) {
    return props.active ? 1 : 0;
}, function (props) {
    return props.active ? 'all' : 'none';
}, _theme_1.breakpoint.tablet, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop);
var SocialItem = styled_components_1.default.li.withConfig({
    displayName: "SocialSharingMenu__SocialItem",
    componentId: "vqd05t-3"
})(["position:relative;display:block;background-color:", ";height:40px;width:40px;border-radius:50%;&::before{z-index:-1;position:absolute;top:0;bottom:0;left:0;right:0;border:20px solid ", ";border-radius:50%;transform:scale3d(0,0,1);transform-origin:center;opacity:0.6;content:'';}@media only screen and (min-width:", "){transform:translate3d(0,0,0) scale3d(1,1,1);transition:background-color 0.25s ease-in-out,transform 0.4s ease-in-out;will-change:background,transform;&:hover{background-color:", ";transform:translate3d(0,-2px,0) scale3d(1.05,1.05,1);}&:hover::before{transition:opacity 0.8s ease-in-out,transform 0.8s ease-in-out;transform:scale3d(1.6,1.6,1);opacity:0;}}@media only screen and (min-width:", "){height:48px;width:48px;&::before{border-width:24px;}}@media only screen and (min-width:", "){height:64px;width:64px;&::before{border-width:32px;}}"], _theme_1.palette.ink, function (props) {
    return props.color;
}, _theme_1.breakpoint.tablet, function (props) {
    return props.color;
}, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop);
var SocialLink = styled_components_1.default.a.withConfig({
    displayName: "SocialSharingMenu__SocialLink",
    componentId: "vqd05t-4"
})(["display:block;background-color:", ";height:100%;mask-repeat:no-repeat;mask-position:center center;mask-size:18px auto;", " text-indent:-99999px;overflow:hidden;@media only screen and (min-width:", "){mask-size:20px auto;}@media only screen and (min-width:", "){mask-size:24px auto;}"], _theme_1.palette.snow, function (props) {
    return props.logo && "\n    mask-image: url(" + props.logo + ");\n  ";
}, _theme_1.breakpoint.laptop, _theme_1.breakpoint.desktop); // Typing
exports.default = SocialSharingMenu;
